import { VirtualizedListItem } from "../../components/virtualized-list/VirtualizedList";
import { IKeyValuePair } from "../../common/models/KeyValuePair";
import { IPollingScheduleDataModel, IPollingScheduleObjectModel, ITagPollingScheduleData } from "../../services/polling-frequency-data-service/Models";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { ITagAssociationType } from "../../common/models/ITagAssociationType";
import Enumerable from "linq";

export type PollingFrequencyFormObject = {
    id: number;
    objectType: eLynxObjectTypeEnum;
    label: string;
    selected: boolean;
    fieldKey: string;

    tatsInUse: number[];

} & VirtualizedListItem;

export type PollingFrequencyForm = {

    devices: PollingFrequencyFormObject[];
    tanks: PollingFrequencyFormObject[];
    tats: PollingFrequencyFormObject[];

    newSchedule: number;
};

export const pollingScheduleOptions: IKeyValuePair<number, string>[] = [{
        Key: -1,
        Value: '',
    },{
        Key: 4,
        Value: '1 Min',
    },{
        Key: 3,
        Value: '5 Min',
    },{
        Key: 2,
        Value: '10 Min',
    },{
        Key: 1,
        Value: '15 Min',
    },{
        Key: 5,
        Value: '30 Min',
    },{
        Key: 6,
        Value: '60 Min',
    },{
        Key: 7,
        Value: '240 Min (6 per Day)',
    },{
        Key: 8,
        Value: '360 Min (4 per Day)',
    },{
        Key: 9,
        Value: '1440 Min (1 per Day)',
    },{
        Key: 10,
        Value: 'No Scheduled Poll (Demand Scan only)',
    }
];



export const defaultPollingFrequencyForm: PollingFrequencyForm = {
    
    devices: [],
    tanks: [],
    tats: [],
    newSchedule: -1
};

function mapToFrequencyFormObjects(models: IPollingScheduleObjectModel[], objectType: eLynxObjectTypeEnum) {

    return models.filter(o => o.object.objectType === objectType).map((o) => {
        return {
            id: o.object.id,
            label: o.object.displayText ?? '',
            objectType: objectType,
            selected: false,
            fieldKey: '',            
            tatsInUse: o.tagPollingSchedules.map(v => v.tagAssociationTypeID)
        } as PollingFrequencyFormObject;
    }).sort((a, b) => (a.label).localeCompare(b.label));
}

function mapToFrequencyFormTats(models: ITagAssociationType[]) {

    return models.map((o, ndx) => {
        return {
            id: o.id,
            label: o.name,
            objectType: eLynxObjectTypeEnum.Tag,
            selected: false,
            tatsInUse: [],
            fieldKey: ''
        } as PollingFrequencyFormObject;
    }).sort((a, b) => (a.label).localeCompare(b.label));
}


const PollingFrequencyUtils = {
    mapToModel: (originalModel: IPollingScheduleDataModel,
        form: PollingFrequencyForm
    ): ITagPollingScheduleData[] => {

        const pollingSchedules: ITagPollingScheduleData[] = [];

        const selectedTats = form.tats.filter(o => o.selected);

        const selectedObjects = form.devices.filter(o => o.selected).concat(form.tanks.filter(o => o.selected));

        selectedObjects.forEach(o => {

            const pollingObject = originalModel.pollingSchedules.find(v => v.object.id === o.id && v.object.objectType === o.objectType);

            if (pollingObject) {

                const tats = selectedTats.length > 0 ? Enumerable.from(o.tatsInUse)
                    .join(selectedTats,
                        o => o,
                        v => v.id,
                        (o, v) => o)
                    .toArray() :
                    o.tatsInUse;

                

                tats.forEach(v => {

                    const tagData = pollingObject.tagPollingSchedules.find(x => x.tagAssociationTypeID === v);

                    if (tagData && tagData.pollingSchedule !== form.newSchedule) {
                        pollingSchedules.push({...tagData,
                            pollingSchedule: form.newSchedule
                        } as ITagPollingScheduleData)
                    }
                });
            }
        });

        return pollingSchedules;
    },
    mapToFormValues: (model: IPollingScheduleDataModel): PollingFrequencyForm  => {

        const formValues: PollingFrequencyForm = {

            devices: mapToFrequencyFormObjects(model.pollingSchedules, eLynxObjectTypeEnum.Device),
            tanks: mapToFrequencyFormObjects(model.pollingSchedules, eLynxObjectTypeEnum.Tank),
            tats: [],
            newSchedule: -1
        };

        const tatsInUse = Enumerable.from(model.pollingSchedules)
                    .selectMany(o => o.tagPollingSchedules)
                    .distinct(o => o.tagAssociationTypeID)
                    .join(model.tats,
                        o => o.tagAssociationTypeID,
                        v => v.id,
                        (o, v) => v
                    )
                    .toArray();

        formValues.tats = mapToFrequencyFormTats(tatsInUse);

        return formValues;
    },
    // mapToTatFormValues: (form: PollingFrequencyForm, 
    // selectedObjects: PollingFrequencyFormObject[]) : 
    // PollingFrequencyFormObject[] => {


    //     if (selectedObjects.length === 0) {
    //         return form.tats;
    //     }



    // }
    // formIsDirty: function(dirtyFields: Partial<Readonly<FieldNamesMarkedBoolean<ScheduleReportsFormDirtyType>>>): boolean {

    //     const scheduleIsDirty = (item: PollingFrequencyFormDirtyType) => {

    //         return (item.description === true ||
        
    //             item.repeatRange === true ||
    //             item.repeatInterval === true ||
    //             item.timezoneIndex === true ||
    //             item.startTime === true ||
    //             item.endTime === true ||
    //             item.isActive === true ||
    //             item.dayOfMonth === true ||
    //             item.dayOfWeek === true ||
    //             item.hour === true ||
    //             item.minute === true);
    //     };

    //     const recipientIsDirty = (item: PollingFrequencyRecipientDirtyType) => {
    //         return item.selected;
    //     };

    //     const notificationListIsDirty = (item: PollingFrequencyNotificationListDirtyType) => {
    //         return item.selected;
    //     };
        
    //     return (dirtyFields.reportConfigID === true ||
    //         dirtyFields.exportFormat === true ||
    //         dirtyFields.reportType === true ||
    //         dirtyFields.description === true ||
    //         (dirtyFields.schedules?.some(o => scheduleIsDirty(o)) ?? false) ||
    //         (dirtyFields.recipients?.some(o => recipientIsDirty(o)) ?? false) ||
    //         (dirtyFields.notificationLists?.some(o => notificationListIsDirty(o)) ?? false));

    // }
}

export default PollingFrequencyUtils;
